const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"] as const;
// type UtmKey = (typeof UTM_KEYS)[number];

export interface UtmParams {
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
}

/**
 * Call this once on app load (e.g. in App.tsx).
 * Reads UTM params from the current URL and saves them to sessionStorage
 * so they survive navigation but are cleared when the tab closes.
 */
export function captureUtmParams(): void {
  const params = new URLSearchParams(window.location.search);
  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      sessionStorage.setItem(key, value);
    }
  });
}

/**
 * Returns the stored UTM params. Call this during signup.
 */
export function getStoredUtmParams(): UtmParams {
  return {
    utm_source: sessionStorage.getItem("utm_source"),
    utm_medium: sessionStorage.getItem("utm_medium"),
    utm_campaign: sessionStorage.getItem("utm_campaign"),
  };
}

/**
 * Clears stored UTM params (call after a successful signup if desired).
 */
export function clearUtmParams(): void {
  UTM_KEYS.forEach((key) => sessionStorage.removeItem(key));
}
